import { jsx, jsxs } from 'react/jsx-runtime';
import { styled } from '@flex-design-system/stitches-react';
import { useId } from '@radix-ui/react-id';
import { forwardRef, useState, useCallback } from 'react';
import '../../utils/styles/flex.mjs';
import Stack from '../../utils/styles/stack.mjs';
import { BaseTextField } from './base/textField/BaseTextField.mjs';
import { TextFieldProvider } from './base/textField/context.mjs';
import HelperText from './base/textField/HelperText.mjs';
import LabelImpl from './base/textField/Label.mjs';
import TextFieldLabel_Legacy from './base/textField/Label_Legacy.mjs';
import PasswordTextField from './PasswordTextField.mjs';
import { root } from './textField.vanilla.mjs';

const InnerTextField = forwardRef(
  ({
    __scopeTextField,
    size = "default",
    required = false,
    variant = "outline",
    helperText,
    ...props
  }, forwardedRef) => {
    const [describeBy, _setDescribedBy] = useState();
    const [labelledBy, _setLabelledBy] = useState();
    const setDescribedBy = useCallback((describeById) => {
      _setDescribedBy(describeById);
    }, []);
    const setLabelledBy = useCallback((labelledById) => {
      _setLabelledBy(labelledById);
    }, []);
    const inputId = useId(props?.id);
    const TextFieldComponent = props.type === "password" ? PasswordTextField : BaseTextField;
    return /* @__PURE__ */ jsx(
      TextFieldProvider,
      {
        scope: __scopeTextField,
        size,
        required,
        state: props.state,
        disabled: props.disabled,
        setDescribedBy,
        setLabelledBy,
        children: /* @__PURE__ */ jsxs(
          Stack.Vertical,
          {
            className: root,
            space: 8,
            "data-scope": "text-field",
            "data-part": "root",
            children: [
              /* @__PURE__ */ jsx(
                TextFieldComponent,
                {
                  ...props,
                  variant,
                  id: inputId,
                  size,
                  required,
                  describeBy,
                  labelledBy,
                  ref: forwardedRef
                }
              ),
              helperText
            ]
          }
        )
      }
    );
  }
);
const TextField = Object.assign({}, InnerTextField, {
  /**
   * @deprecated Required 마크가 라벨 마지막 글자 뒤에 붙도록 수정되었습니다. 새롭게 만들어진 Label 를 사용해 주세요.
   * https://linear.app/flexteam/issue/FX-5/[linearlabel]-required-%EB%A7%88%ED%81%AC-%ED%85%8D%EC%8A%A4%ED%8A%B8-%EC%98%86%EC%9C%BC%EB%A1%9C-%EC%9D%B4%EB%8F%99
   */
  Label_Legacy: styled(TextFieldLabel_Legacy),
  Label: styled(LabelImpl),
  HelperText: styled(HelperText)
});

export { TextField as default };
//# sourceMappingURL=TextField.mjs.map
